import {IEventProductData} from 'coreClasses/events/IEvents';
import ManagerRepository from 'coreClasses/ManagerRepository';
import ProductModel from 'coreClasses/product/ProductModel';
import {IBasketProductLineItem} from 'coreInterfaces/common/IBasket';
import ECommerceProductDetailsModel from './EcommerceProductDetailsModel';

/**
 * Represents EcommerceProductLineItemModel
 */
export default class EcommerceProductLineItemModel extends ECommerceProductDetailsModel {
	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventProductData} productData - product data
	 * @param {IBasketProductLineItem} productItem - product line item
	 */
	constructor(
		managerRepository: ManagerRepository,
		productData: IEventProductData,
		productItem: IBasketProductLineItem
	) {
		super(managerRepository, productData, productItem);

		const product: ProductModel = productData.product;

		if (product?.isReady() && 'attributes' in productData) {
			for (let attribute in productData.attributes) {
				this[attribute] = productData.attributes[attribute];
			}
		}

		if (!product.isVariationGroup()) {
			const variationGroup = managerRepository.getProductsMgr().getProduct(
				productItem?.c_variationGroupId,
			) as ProductModel;

			if (variationGroup) {
				this.category = variationGroup.getPrimaryCategoryId();
			}
		}
	}
};
